import { APARTMENT_GROUP_ID, VILLA_GROUP_ID } from "./Constants";

export const emirates = [
  {
    id: 1,
    name: "Abu Dhabi",
    latitude: 24.5498411,
    longitude: 54.5345891,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 2,
    name: "Ajman",
    latitude: 25.3994763,
    longitude: 55.495555,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 3,
    name: "Al Ain",
    latitude: 24.1932413,
    longitude: 55.6067828,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 4,
    name: "Dubai",
    latitude: 25.1045972,
    longitude: 55.2318831,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 5,
    name: "Fujairah",
    latitude: 25.1437088,
    longitude: 56.2918741,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 6,
    name: "Ras Al Khaimah",
    latitude: 25.7266329,
    longitude: 55.8281932,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 7,
    name: "Umm Al Quwain",
    latitude: 25.5099654,
    longitude: 55.5956107,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
  {
    id: 8,
    name: "Sharjah",
    latitude: 25.3167825,
    longitude: 55.441145,
    status: 1,
    created_at: "2020-03-29T11:26:09Z",
    updated_at: "2020-03-29T11:26:09Z",
  },
];

export const location = [
  {
    id: 872,
    location_id: 872,
    name: "Princess Tower, Dubai Marina",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Marsa Dubai",
    master_development: "Dubai Marina",
    sub_location_1: "Princess Tower",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0888074130027,
    longitude: 55.1469201950218,
    reference_id: 872,
    ref_location_id: 872,
  },
  {
    id: 4344,
    location_id: 4344,
    name: "Dusit Princess Rijas, Jumeirah Village Circle",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Barsha South Fourth",
    master_development: "Jumeirah Village Circle",
    sub_location_1: "Dusit Princess Rijas",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0515828,
    longitude: 55.1993448,
    reference_id: 4344,
    ref_location_id: 4344,
  },
  {
    id: 8729,
    location_id: 8729,
    name: "Al Maraya, Al Badaa",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Bada",
    master_development: "Al Badaa",
    sub_location_1: "Al Maraya",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 0,
    longitude: 0,
    reference_id: 8729,
    ref_location_id: 8729,
  },
  {
    id: 2210,
    location_id: 2210,
    name: "Ashjar, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "Ashjar",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0981415,
    longitude: 55.2987062,
    reference_id: 2210,
    ref_location_id: 2210,
  },
  {
    id: 10919,
    location_id: 10919,
    name: "Chorisia Villas, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "Chorisia Villas",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.100706,
    longitude: 55.31213,
    reference_id: 11041,
    ref_location_id: 11041,
  },
  {
    id: 2071,
    location_id: 2071,
    name: "Seventh Heaven, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "Seventh Heaven",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0981415,
    longitude: 55.2987062,
    reference_id: 2071,
    ref_location_id: 2071,
  },
  {
    id: 11267,
    location_id: 11267,
    name: "The Collection, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "The Collection",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.10146,
    longitude: 55.303835,
    reference_id: 11514,
    ref_location_id: 11514,
  },
  {
    id: 4649,
    location_id: 4649,
    name: "The Neighbourhood, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "The Neighbourhood",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 0,
    longitude: 0,
    reference_id: 4649,
    ref_location_id: 4649,
  },
  {
    id: 3637,
    location_id: 3637,
    name: "The Nest, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "The Nest",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.10146,
    longitude: 55.303835,
    reference_id: 3637,
    ref_location_id: 3637,
  },
  {
    id: 11268,
    location_id: 11268,
    name: "The Reserve, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "The Reserve",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0981415,
    longitude: 55.2987062,
    reference_id: 11515,
    ref_location_id: 11515,
  },
  {
    id: 11260,
    location_id: 11260,
    name: "The Residences, Al Barari",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 3",
    master_development: "Al Barari",
    sub_location_1: "The Residences",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0981415,
    longitude: 55.2987062,
    reference_id: 11507,
    ref_location_id: 11507,
  },
  {
    id: 9899,
    location_id: 9899,
    name: "Saraya Avenue, Al Garhoud",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Garhoud",
    master_development: "Al Garhoud",
    sub_location_1: "Saraya Avenue",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 0,
    longitude: 0,
    reference_id: 9599,
    ref_location_id: 9599,
  },
  {
    id: 10505,
    location_id: 10505,
    name: "Barajeel Residency, Al Jaddaf",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "",
    master_development: "Al Jaddaf",
    sub_location_1: "Barajeel Residency",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.221618,
    longitude: 5.334811,
    reference_id: 10617,
    ref_location_id: 10617,
  },
  {
    id: 9367,
    location_id: 9367,
    name: "J3 Mall, Al Manara",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Manara",
    master_development: "Al Manara",
    sub_location_1: "J3 Mall",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.147,
    longitude: 55.211,
    reference_id: 9669,
    ref_location_id: 9669,
  },
  {
    id: 7710,
    location_id: 7710,
    name: "Rajabali Villas, Al Manara",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Manara",
    master_development: "Al Manara",
    sub_location_1: "Rajabali Villas",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 0,
    longitude: 0,
    reference_id: 7710,
    ref_location_id: 7710,
  },
  {
    id: 7062,
    location_id: 7062,
    name: "Emarat Atrium, Al Wasl",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Al Wasl",
    master_development: "Al Wasl",
    sub_location_1: "Emarat Atrium",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 0,
    longitude: 0,
    reference_id: 7062,
    ref_location_id: 7062,
  },
  {
    id: 7299,
    location_id: 7299,
    name: "Arabian Ranches Golf Club, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Arabian Ranches Golf Club",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0523684,
    longitude: 55.2673602,
    reference_id: 7299,
    ref_location_id: 7299,
  },
  {
    id: 7300,
    location_id: 7300,
    name: "Arabian Ranches Retail Centre, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Arabian Ranches Retail Centre",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0523684,
    longitude: 55.2673602,
    reference_id: 7300,
    ref_location_id: 7300,
  },
  {
    id: 52,
    location_id: 52,
    name: "Aseel Villas, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Aseel Villas",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0523684,
    longitude: 55.2673602,
    reference_id: 52,
    ref_location_id: 52,
  },
  {
    id: 54,
    location_id: 54,
    name: "Golf Homes, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Golf Homes",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0494332,
    longitude: 55.2589238,
    reference_id: 54,
    ref_location_id: 54,
  },
  {
    id: 36,
    location_id: 36,
    name: "Hattan, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Hattan",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0466597,
    longitude: 55.2651947,
    reference_id: 36,
    ref_location_id: 36,
  },
  {
    id: 57,
    location_id: 57,
    name: "Palm Grove, Arabian Ranches",
    level: 3,
    emirate_id: 4,
    emirate: "Dubai",
    arabic_name: "Wadi Al Safa 6",
    master_development: "Arabian Ranches",
    sub_location_1: "Palm Grove",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    sub_location_5: "",
    latitude: 25.0523684,
    longitude: 55.2673602,
    reference_id: 57,
    ref_location_id: 57,
  },
];

export const unitNumber = [
  {
    id: 207322,
    property_old_address:
      "Property No. 604, Plot No. 22, Building No. 1, Marsa Dubai, Dubai, United Arab Emirates",
    property_new_address:
      "Property No. 604, Princess Tower, Dubai Marina, Dubai, United Arab Emirates",
    emirate: "Dubai",
    zone_sector: "2",
    area: 330,
    municipality_plot_no: "22",
    land_sub_number: "",
    gps_latitude: "25.0888074130027",
    gps_longitude: "55.1469201950218",
    arabic_community: "Marsa Dubai",
    master_development: "Dubai Marina",
    sub_location_1: "Princess Tower",
    sub_location_2: "",
    sub_location_3: "",
    sub_location_4: "",
    street_name: "",
    location_id: 872,
    ref_location_id: 872,
    unit_number: "604",
    building_number: "1",
    property_address: "Princess Tower",
    property_type_id: 1,
    built_up_area_sqft: "1694.45",
    built_up_area_sqm: "157.42",
    plot_size_sqft: "",
    plot_size_sqm: "",
    makani_number: "13120 76063",
    dewa_number: "392308827",
    door_number: "604",
    last_title_deed: "",
    floor: "6",
    parking: "B6-14",
    no_of_parking: "1",
    parcel_id: 3920192,
    bedrooms: "2",
    bathrooms: "",
    views: "",
    developer_name: "Tameer Holding Investment",
    developer_name_slug: "tameer-holding-investment",
    total_service_charges: "15.8",
    development_status_id: 1,
    completion_date: "2012-01-01",
    balcony_area_sqft: "59.74",
    balcony_area_sqm: "5.55",
    manual: 0,
    reference_id: 354897,
    data_type: "Units",
  },
];
export const INITIAL_MAP_VALUE = {
  lat: 25.1045972,
  lng: 55.2318831,
};

export const PROPERTY_TYPES = [
  {
    id: 1,
    name: "Apartment",
    category: "residential",
    status: 1,
    property_type_group: 1,
  },
  {
    id: 8,
    name: "Villa",
    category: "residential",
    status: 1,
    property_type_group: 3,
  },
  {
    id: 10,
    name: "Townhouse",
    category: "residential",
    status: 1,
    property_type_group: 3,
  },
];

export const VIEWS = [
  { id: 30, name: "Atlantis", property_type: "Apartment", status: 1 },
  {
    id: 25,
    name: "Back to Back",
    property_type: "Villa/Townhouse",
    status: 1,
  },
  { id: 32, name: "Burj Khalifa", property_type: "Apartment", status: 1 },
  { id: 17, name: "Power Lines", property_type: "Villa/Townhouse", status: 1 },
  { id: 27, name: "Canal", property_type: "Apartment", status: 1 },
  { id: 26, name: "Community", property_type: "All", status: 1 },
  { id: 31, name: "Fountains", property_type: "Apartment", status: 1 },
  { id: 35, name: "Golf Course", property_type: "All", status: 1 },
  {
    id: 24,
    name: "Internal Road",
    property_type: "Villa/Townhouse",
    status: 1,
  },
  { id: 33, name: "Lake", property_type: "Villa/Townhouse", status: 1 },
  { id: 28, name: "Marina", property_type: "Apartment", status: 1 },
  { id: 34, name: "Park", property_type: "All", status: 1 },
  { id: 18, name: "Road", property_type: "Villa/Townhouse", status: 1 },
  { id: 29, name: "Sea", property_type: "Apartment", status: 1 },
  {
    id: 43,
    name: "Sheikh Zayed Road",
    property_type: "Apartment",
    status: 1,
  },
  {
    id: 42,
    name: "Single Row",
    property_type: "Villa/Townhouse",
    status: 1,
  },
  { id: 38, name: "Swimming Pool", property_type: "All", status: 1 },
  { id: 1, name: "Vacant Land", property_type: "All", status: 1 },
];

export const UPGRADES = [
  {
    id: 1,
    name: "Bathroom",
    value: 0,
    propertyTypeGroup:[APARTMENT_GROUP_ID,VILLA_GROUP_ID]
  },
  {
    id: 2,
    name: "Flooring",
    value: 0,
    propertyTypeGroup:[APARTMENT_GROUP_ID,VILLA_GROUP_ID]
  },
  {
    id: 3,
    name: "Kitchen",
    value: 0,
    propertyTypeGroup:[APARTMENT_GROUP_ID,VILLA_GROUP_ID]
  },

  {
    id: 4,
    name: "Landscape Garden",
    value: 0,
    propertyTypeGroup:[VILLA_GROUP_ID]
  },
  {
    id: 5,
    name: "Swimming Pool",
    value: 0,
    propertyTypeGroup:[VILLA_GROUP_ID]
  },
];
export const UPGRADES_OPTIONS = [
  {
    id: 1,
    name: "Partially Upgraded",
    value: 1,
  },
  {
    id: 2,
    name: "Fully Upgraded",
    value: 2,
  },
  {
    id: 3,
    name: "None",
    value: 0,
  },
];

export const DLD_LABELS = {
  date:"Transfer Date",
  price:"Price",
  sqFt:"sq ft",
  bed:"bed",
  floor:"floor",
  plot:"plot",
  unit:"unit",
}

export const ACTIVE_LISTINGS_LABEL = {
  date:"Listing Date",
  price:"Asking Price",
  dom:"Days on Market",
  sqFt:"sq ft",
  bed:"bed",
  floor:"floor",
  plot:"plot",
  unit:"unit",
}